import React, { useState } from 'react';
import DashboardWidgetNew from './DashboardWidgetNew';

const Repos = () => {
  const [filters, setFilters] = useState({});

  const getChartTitle = filters => {
    if (filters.operation === 'investment') {
      return 'Project Based Investment Trend ($)';
    }
    if (filters.operation === 'git_effort') {
      return 'Project Based Effort Trend';
    }
    return 'Project Based Commit Trend';
  };

  const dashboardFilters = filter => {
    setFilters(filter);
  };

  return (
    <DashboardWidgetNew
      category="projects"
      dashboardFilters={dashboardFilters}
      isHidden={['projects']}
      forceClearMultiFilters={['projects']}
      title={{
        chartTitle: getChartTitle(filters),
        pieTitle: 'Projects - Pie',
        tableColumnName: 'Projects'
      }}
    />
  );
};

export default Repos;
